import { render, staticRenderFns } from "./giftVideo.vue?vue&type=template&id=3528e1e4&scoped=true"
import script from "./giftVideo.vue?vue&type=script&lang=js"
export * from "./giftVideo.vue?vue&type=script&lang=js"
import style0 from "./giftVideo.vue?vue&type=style&index=0&id=3528e1e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3528e1e4",
  null
  
)

export default component.exports